import React from 'react';
import { FadeIn } from './FadeIn';
import { motion } from 'framer-motion';
export function TomosSection() {
  const tomos = [{
    icon: '📸',
    title: 'Tomo 1',
    desc: 'Prompts para fotos premium y branding visual',
    color: 'from-[#c9a961]/10 to-transparent',
    border: 'border-t-[#c9a961]'
  }, {
    icon: '📱',
    title: 'Tomo 2',
    desc: 'Reels, carruseles, historias y hooks virales',
    color: 'from-[#d4af37]/10 to-transparent',
    border: 'border-t-[#d4af37]'
  }, {
    icon: '💬',
    title: 'Tomo 3',
    desc: 'Copies, captions, anuncios y storytelling',
    color: 'from-[#b8860b]/10 to-transparent',
    border: 'border-t-[#b8860b]'
  }, {
    icon: '📢',
    title: 'Tomo 4',
    desc: 'Estructura de ads, textos y ganchos psicológicos',
    color: 'from-[#8b6914]/10 to-transparent',
    border: 'border-t-[#8b6914]'
  }, {
    icon: '💚',
    title: 'Tomo 5',
    desc: 'Scripts para consultas, cierres y recuperación',
    color: 'from-[#c9a961]/10 to-transparent',
    border: 'border-t-[#c9a961]'
  }, {
    icon: '⏱️',
    title: 'Tomo 6',
    desc: 'Método completo idea + imagen + copy',
    color: 'from-[#d4af37]/10 to-transparent',
    border: 'border-t-[#d4af37]'
  }];
  return <section className="py-8 md:py-16 px-4 max-w-6xl mx-auto" data-id="element-401">
      <FadeIn data-id="element-402">
        <h2 className="text-2xl md:text-5xl font-black text-[#1a1611] text-center mb-6 md:mb-14 flex items-center justify-center gap-3 md:gap-4" data-id="element-403">
          <span className="text-3xl md:text-5xl drop-shadow-[0_0_15px_rgba(201,169,97,0.3)]" data-id="element-404">
            📚
          </span>{' '}
          LOS 6 TOMOS
        </h2>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-8" data-id="element-405">
        {tomos.map((tomo, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-406">
            <motion.div whileHover={{
          y: -5,
          scale: 1.02
        }} transition={{
          type: 'spring',
          stiffness: 300
        }} className={`bg-white border border-[#e8dfd0] ${tomo.border} border-t-4 hover:border-[#c9a961] transition-all rounded-2xl p-4 md:p-8 h-full flex flex-col relative overflow-hidden shadow-sm hover:shadow-xl`} data-id="element-407">
              <div className={`absolute inset-0 bg-gradient-to-b ${tomo.color} opacity-50 pointer-events-none`} data-id="element-408"></div>

              <div className="absolute top-3 right-3 md:top-4 md:right-4 text-[10px] md:text-xs font-black tracking-widest text-[#b8860b] bg-[#faf7f2] px-2 py-0.5 md:px-3 md:py-1 rounded-full border border-[#e8dfd0]" data-id="element-409">
                TOMO 0{index + 1}
              </div>

              <div className="text-4xl md:text-6xl mb-3 md:mb-6 relative z-10 drop-shadow-sm" data-id="element-410">
                {tomo.icon}
              </div>

              <h3 className="text-lg md:text-2xl font-black text-[#1a1611] mb-1.5 md:mb-3 relative z-10" data-id="element-411">
                {tomo.title}
              </h3>

              <p className="text-sm md:text-base text-[#6b5d4f] font-medium leading-relaxed flex-grow relative z-10" data-id="element-412">
                {tomo.desc}
              </p>
            </motion.div>
          </FadeIn>)}
      </div>
    </section>;
}